import { required, helpers } from '@vuelidate/validators'
import { useVuelidate } from '@vuelidate/core'
import ErrorList from './ErrorList'
import { stepsConstants } from '../../data/steps'
import dayjs from 'dayjs'

const dateFormatDisplay = 'DD.MM.YYYY'
const dateFormatIntern = 'YYYY-MM-DD'

export default {
  props: ['formData', 'formOptions', 'formLabels'],
  components: {
    ErrorList
  },
  data () {
    return {
      minDate: null,
      maxDate: null
    }
  },
  methods: {
    onChange (e) {
      // console.log('@change', e.target.name, e.target.value)
    },
    setErrorId(fieldName) {
      const errors = this.v$.formData[fieldName].$errors
      return errors.length ? `errors--${fieldName}` : null
    },
  },
  setup: () => {
    const now = dayjs()

    return {
      v$: useVuelidate(),
      minDate: now.subtract(120, 'year').startOf('date'),
      maxDate: now.endOf('date')
    }
  },
  validations () {
    const minDateError = 'Das eingegebene Datum darf nicht vor dem ' + this.minDate.format(dateFormatDisplay) + ' liegen.'

    return {
      formData: {
        gender: {
          required: helpers.withMessage(stepsConstants.please_fill_field_correctly, required)
        },
        firstname: {
          required: helpers.withMessage(stepsConstants.please_fill_field_correctly, required)
        },
        lastname: {
          required: helpers.withMessage(stepsConstants.please_fill_field_correctly, required)
        },
        salutation: {},
        birthday: {
          required: helpers.withMessage('Bitte geben Sie ein valides Datum ein.', required),
          minValue: helpers.withMessage(minDateError, val => this.minDate.toDate() <= new Date(val)),
          maxValue: helpers.withMessage('Das eingegebene Datum darf nicht nach dem heutigen Datum liegen.', val => new Date(val) <= this.maxDate.toDate())
        }
      }
    }
  },
  computed: {
    maxDateNice () {
      return this.maxDate ? this.maxDate.format(dateFormatDisplay) : ''
    },
    minDateNice () {
      return this.minDate ? this.minDate.format(dateFormatDisplay) : ''
    },
    maxDateIntern () {
      return this.maxDate ? this.maxDate.format(dateFormatIntern) : ''
    },
    minDateIntern () {
      return this.minDate ? this.minDate.format(dateFormatIntern) : ''
    }
  },
  template: `
    <div class="application__fields__input-group" style="--inputgroup-width:100%">
        <label class="form__label" for="gender">{{formLabels['gender']}}<span class="form__mandatory">*</span></label>
        <select :aria-describedby="setErrorId('gender')" required name="gender" id="gender" v-model="formData.gender" @change="onChange" class="form__select form__select--no-replace">
            <option value="" disabled selected>Bitte wählen Sie aus ...</option>
            <option v-for="text in formOptions.gender" :key="text" :value="text">{{text}}</option>
        </select>
        <error-list :errors="v$.formData.gender.$errors" :id="setErrorId('gender')"/>
    </div>

    <div class="application__fieldset">
        <div class="application__fields__input-group application__fields__input-group--flex-1">
            <label for="firstname" class="form__label">{{formLabels['firstname']}}<span class="form__mandatory">*</span></label>
            <input :aria-describedby="setErrorId('firstname')" type="text" v-model="formData.firstname" name="firstname" id="firstname" class="form__input" placeholder="" autocomplete="given-name" required>
            <p class="application__info-text">Angabe wie im Personalausweis</p>
            <error-list :errors="v$.formData.firstname.$errors" :id="setErrorId('firstname')"/>
        </div>

        <div class="application__fields__input-group application__fields__input-group--flex-1">
            <label for="lastname" class="form__label">{{formLabels['lastname']}}<span class="form__mandatory">*</span></label>
            <input :aria-describedby="setErrorId('lastname')" type="text" v-model="formData.lastname" name="lastname" id="lastname" class="form__input" placeholder="" autocomplete="family-name" required>
            <p class="application__info-text">Angabe wie im Personalausweis</p>
            <error-list :errors="v$.formData.lastname.$errors" :id="setErrorId('lastname')"/>
        </div>
    </div>
    
    <div class="application__fields__input-group" style="--inputgroup-width:100%">
      <label for="birthdate" class="form__label">{{formLabels['birthday']}}<span class="form__mandatory">*</span></label>
      <input type="date"
        :min="minDateIntern"
        :max="maxDateIntern"
        v-model="formData.birthday"
        name="birthdate"
        autocomplete="bday"
        id="birthdate"
        class="form__input form__date"
        :aria-describedby="setErrorId('birthday')"
        required>
  
      <error-list :errors="v$.formData.birthday.$errors" :id="setErrorId('birthday')"/>
  </div>

    <h3>Optionale Angaben</h3>

    <div class="application__fields__input-group" style="--inputgroup-width:100%">
        <label class="form__label" for="salutation">{{formLabels['salutation']}}</label>
        <select :aria-describedby="setErrorId('salutation')" name="salutation" v-model="formData.salutation" id="salutation" class="form__select form__select--no-replace">
            <option value="" selected>Bitte wählen Sie aus ...</option>
            <option v-for="text in formOptions.salutation" :key="text" :value="text">{{text}}</option>
        </select>
        <error-list :errors="v$.formData.salutation.$errors" :id="setErrorId('salutation')"/>
    </div>
    `
}
